import UIStrings from '@/Utils/UIStrings';

interface AccountHasBeenRevokedProps {
    companyName: string;
}

function AccountHasBeenRevoked({ companyName }: AccountHasBeenRevokedProps) {
    return (
        <p className="text-foreground text-sm">
            {`${UIStrings.YourAccountHasBeenRevoked}. `}
            {`${UIStrings.YouCanNoLongerJoin} `}
            <span className="font-semibold">{`${companyName}. `}</span>
            {UIStrings.InvitationMistakeMessage}
        </p>
    );
}

export default AccountHasBeenRevoked;
